export const transformBrandCategoryData = (brandCategoryProductsData) => {
  const productCategoryMap = {};
  const allExtrasForBrand = [];
  const allProductsForBrand = [];

  const extractExtraFromProduct = (product) => {
    product.extra_groups.forEach((extraGroup) => {
      extraGroup.items.forEach((extraItem) => {
        allExtrasForBrand.push({ ...extraItem, product });
      });
    });
  };

  if (
    brandCategoryProductsData &&
    Array.isArray(brandCategoryProductsData.brandCategoryProductsByStore)
  ) {
    brandCategoryProductsData.brandCategoryProductsByStore.forEach(
      (storeGroup) => {
        storeGroup.categories.forEach((cat) => {
          cat.product_ids.forEach((prod) => {
            productCategoryMap[prod] = {
              ...(productCategoryMap[prod] || {}),
              [cat.id]: storeGroup.store_id,
            };
          });

          cat.products.forEach((product) => {
            allProductsForBrand.push(product);

            if (!product || !Array.isArray(product.extra_groups)) return;

            extractExtraFromProduct(product);

            const variants = product.variants || [];
            variants.forEach((variant) => {
              extractExtraFromProduct(variant);
            });
          });
        });
      },
    );
  }
  return {
    productCategoryMap,
    allExtrasForBrand,
    allProductsForBrand,
  };
};

export const changeOrderHelper = (itemArray, idAttrName, id, targetId) => {
  const sorted = Array.from(itemArray);
  const from = sorted.findIndex((item) => item[idAttrName] === id);
  const to = sorted.findIndex((item) => item[idAttrName] === targetId);
  const [extraToMove] = sorted.splice(from, 1);
  sorted.splice(to, 0, extraToMove);
  return sorted;
};

export const isNullOrUndefined = (value) =>
  typeof value === 'undefined' || value === null;

export const getProductInput = (touchedProductValues) => {
  let input = touchedProductValues;
  if (input.extra_groups) {
    const { extra_groups, ...rest } = input;
    input = {
      ...rest,
      extra_groups_order: extra_groups.map((eg) => eg.extra_group_id),
    };
  }

  if (input.variants) {
    const defaultVariant = input.variants.find((v) => v.is_default);
    input = {
      ...input,
      variants: {
        default_variant: defaultVariant
          ? defaultVariant.variant_id
          : input.variants[0].variant_id,
        variant_ids: input.variants.map((v) => v.variant_id),
      },
    };
  }

  if (input.published != null) {
    input.reusable_packaging = input.published;
  }

  return input;
};

export const toCsvBlob = (items) => {
  const replacer = (key, value) => (value === null ? '' : value); // specify how you want to handle null values here
  const header = Object.keys(items[0]);
  const csv = [
    header.join(','), // header row first
    ...items.map((row) =>
      header
        .map((fieldName) => JSON.stringify(row[fieldName], replacer))
        .join(','),
    ),
  ].join('\r\n');
  return new Blob([csv], { type: 'text/csv;charset=utf-8;' });
};
